/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Updated_LabelInputs */



/**
* | output |
* | --- |
* | "Last Updated:" |
*
* @param {Preset_Manager_Updated_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_updated_label = /** @type {((inputs?: Preset_Manager_Updated_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Updated_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Derniere mise a jour :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte Aktualisierung:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultimo aggiornamento:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Последнее обновление:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Última actualización:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最后更新时间：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最終更新日:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आखरी अपडेट:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Última atualização:")
	return /** @type {LocalizedString} */ ("Last Updated:")
});